import React, { Component } from "react";
import { reduxForm } from "redux-form";
import Button from "../../../../components/common/button/Button";
import { Form, FormGroup } from "react-bootstrap";
import { connect } from "react-redux";
import { getUserData, getUserDataById } from "../../../../actions/user.actions";
import classNames from "classnames";
import Accordion from "../../professionalSkills/components/Accordion";
import styles from "./SkillsAdmin.scss";

class SkillsAdmin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalSkills: 0
    };

    this.checkTotalSkills = this.checkTotalSkills.bind(this);
  }

  checkTotalSkills(add) {
    this.setState(prevState => {
      return { totalSkills: prevState.totalSkills + (add ? 1 : -1) };
    });
  }

  initialCountSkills(skills) {
    let count = 0;
    if (this.props.dirty == false) {
      Object.keys(skills).forEach(k => {
        count = count + skills[k].length;
      });
      this.setState(prevState => {
        if (prevState.totalSkills != count) {
          return { totalSkills: count };
        }
      });
    }
  }

  componentDidMount() {
    const { memberId } = this.props;
    if (memberId) {
      this.props.getUserDataById(memberId);
    } else {
      this.props.getUserData();
    }
  }

  render() {
    const { submitting, valid, initialValues } = this.props;

    let selectedArray = new Array(7).fill(0);
    if (_.get(initialValues, "skills_all")) {
      this.initialCountSkills(initialValues.skills_all);
      Object.entries(initialValues.skills_all).forEach(skills => {
        selectedArray[parseInt(skills[0] - 1)] = skills[1].length;
      });
    }

    return (
      <section className={styles.skills}>
        <div className={styles.content}>
          <h2 className={styles.title}>Skills</h2>

          <Form onSubmit={this.props.handleSubmit}>
            <div className={styles.form}>
              <FormGroup className={styles.formHeader}>
                <div className={styles.skillsTitle}>
                  What you choose here affects what shows up in your Projects
                  feed.
                </div>
                <div className={styles.skillsSubtitle}>
                  So be thorough, but select only the skills you have experience
                  in.
                </div>
              </FormGroup>
              <FormGroup>
                <div
                  className={classNames([
                    styles.dividerDouble,
                    styles.noMarginBottom
                  ])}
                />

                <FormGroup>
                  <div className={styles.accordion}>
                    {this.props.skills &&
                      this.props.skills.map((el, index) => (
                        <Accordion
                          name={el.name}
                          key={el.id}
                          selectedNumber={selectedArray[index]}
                          expanded={true}
                          checkTotalSkills={this.checkTotalSkills}
                          className={styles.panel}
                          hideCheckbox={true}
                          {...el}
                        />
                      ))}
                  </div>
                </FormGroup>

                <div className={styles.dividerDouble} />

                <div md={12} style={{ textAlign: "center" }}>
                  <Button
                    isPrimary
                    type="submit"
                    size={"large"}
                    label="Save Changes"
                    isDisabled={!valid || submitting || this.props.saving}
                    isLoading={this.props.saving}
                    loadingText="Saving..."
                  />
                </div>
              </FormGroup>
            </div>
          </Form>
        </div>
      </section>
    );
  }
}

SkillsAdmin = reduxForm({
  form: "skills",
  enableReinitialize: true
})(SkillsAdmin);

SkillsAdmin = connect(
  state => {
    return {
      userData: state.user.data,
      saving: state.user.loading,
      initialValues: state.user.data
    };
  },
  dispatch => {
    return {
      getUserData: callback => dispatch(getUserData(callback)),
      getUserDataById: id => dispatch(getUserDataById(id))
    };
  }
)(SkillsAdmin);

export default SkillsAdmin;



// WEBPACK FOOTER //
// ./src/routes/candidate/profile/components/SkillsAdmin.js